(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-merch"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.filter-pill').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.filter-pill').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      var filter = this.dataset.filter;

      document.querySelectorAll('.product-grid__item').forEach(function(card) {
        if (filter === '*') {
          card.style.display = '';
        } else {
          card.style.display = (card.dataset.type || '') === filter ? '' : 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('.filter-pill').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.filter-pill').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      var filter = this.dataset.filter;

      document.querySelectorAll('.product-grid__item').forEach(function(card) {
        if (filter === '*') {
          card.style.display = '';
        } else {
          card.style.display = (card.dataset.tags || '').includes(filter) ? '' : 'none';
        }
      });

      document.querySelectorAll('.js-bundle-section').forEach(function(el) {
        if (filter === '*' || filter === 'bundle') {
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  var container = document.querySelector('[data-search-container]');
  var toggle    = document.querySelector('[data-search-toggle]');
  var form      = document.querySelector('[data-search-form]');
  var input     = document.querySelector('[data-search-input]');

  if (!toggle || !form || !input) return;

  function openSearch() {
    form.classList.add('nav-search-form--open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close search');
    // Small delay so the width transition starts before focus
    setTimeout(function() { input.focus(); }, 50);
  }

  function closeSearch() {
    form.classList.remove('nav-search-form--open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open search');
    input.value = '';
  }

  toggle.addEventListener('click', function() {
    if (form.classList.contains('nav-search-form--open')) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  // Close on Escape
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeSearch();
      toggle.focus();
    }
  });

  // Close when focus leaves the container entirely
  container.addEventListener('focusout', function(e) {
    if (!container.contains(e.relatedTarget)) {
      setTimeout(function() {
        if (!container.contains(document.activeElement)) {
          closeSearch();
        }
      }, 100);
    }
  });

  // Close on click outside
  document.addEventListener('click', function(e) {
    if (!container.contains(e.target)) {
      closeSearch();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-affiliate-signup"]) return;
  try {
    
(function () {
  var section = document.querySelector('.affiliate-signup');
  if (!section) return;

  var FUNCTION_URL = section.dataset.functionUrl;
  var HEADING_SUFFIX = section.dataset.headingSuffix;
  var BUTTON_LABEL = section.dataset.buttonLabel;

  var headingEl = document.getElementById('affiliate-heading');
  var formEl = document.getElementById('affiliate-signup-form');
  var noRefEl = document.getElementById('affiliate-no-ref');
  var successEl = document.getElementById('affiliate-success');
  var errorEl = document.getElementById('affiliate-error');
  var submitBtn = document.getElementById('affiliate-submit');
  var refField = document.getElementById('affiliate-ref');

  var params = new URLSearchParams(window.location.search);
  var ref = params.get('ref');

  function showNoRef() {
    formEl.hidden = true;
    noRefEl.hidden = false;
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function clearError() {
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  function resetSubmit() {
    submitBtn.disabled = false;
    submitBtn.textContent = BUTTON_LABEL;
  }

  if (!ref) {
    showNoRef();
    return;
  }

  // Look up org name from Liquid-generated table (no API call needed)
  var orgs = window.__affiliateOrgs || {};
  var orgName = orgs[ref];

  if (!orgName) {
    showNoRef();
    return;
  }

  headingEl.textContent = 'Join as a ' + orgName + ' ' + HEADING_SUFFIX;
  refField.value = ref;

  // Form submission
  formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    clearError();

    var firstName = formEl.querySelector('[name="firstName"]').value.trim();
    var lastName = formEl.querySelector('[name="lastName"]').value.trim();
    var email = formEl.querySelector('[name="email"]').value.trim();
    var refVal = refField.value;

    if (!firstName || !lastName || !email) {
      showError('Please fill in all required fields.');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError('Please enter a valid email address.');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting\u2026';

    fetch(FUNCTION_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ firstName: firstName, lastName: lastName, email: email, ref: refVal })
    })
      .then(function (r) {
        return r.json().then(function (body) { return { status: r.status, body: body }; });
      })
      .then(function (res) {
        if (res.status === 200) {
          formEl.hidden = true;
          successEl.hidden = false;
        } else {
          showError(res.body.error || 'Something went wrong. Please try again.');
          resetSubmit();
        }
      })
      .catch(function () {
        showError('Something went wrong. Please try again.');
        resetSubmit();
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-merch"]) return;
  try {
    
  (function() {
    // Gallery thumb swap
    var mainImg = document.querySelector('.gallery-main img');
    if (mainImg) {
      document.querySelectorAll('.thumb[data-src]').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          document.querySelectorAll('.thumb').forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          mainImg.src = thumb.dataset.src;
        });
      });
    }

    // Pill selection — update active state, gold label, and ATC variant
    var atcBtn = document.querySelector('[data-atc]');
    var priceEl = document.querySelector('.product-price');
    var qtyVal = document.querySelector('.qty-val');
    var qty = 1;

    // Quantity stepper
    document.querySelector('.qty-minus') && document.querySelector('.qty-minus').addEventListener('click', function() {
      if (qty > 1) { qty--; if (qtyVal) qtyVal.textContent = qty; }
    });
    document.querySelector('.qty-plus') && document.querySelector('.qty-plus').addEventListener('click', function() {
      qty++; if (qtyVal) qtyVal.textContent = qty;
    });

    // Track selected options
    var selectedOptions = {};
    document.querySelectorAll('.merch-pills .pill').forEach(function(pill) {
      if (pill.classList.contains('active')) {
        selectedOptions[pill.dataset.optionIndex] = pill.dataset.optionValue;
      }
    });

    document.querySelectorAll('.merch-pills .pill').forEach(function(pill) {
      pill.addEventListener('click', function() {
        if (pill.classList.contains('sold-out')) return;

        var idx = pill.dataset.optionIndex;

        // Update active pill in this group
        pill.closest('.merch-pills').querySelectorAll('.pill').forEach(function(p) {
          p.classList.remove('active');
        });
        pill.classList.add('active');

        // Update gold label in spec-row above
        var label = document.querySelector('[data-option-val="' + idx + '"]');
        if (label) label.textContent = pill.dataset.optionValue;

        // Track selection
        selectedOptions[idx] = pill.dataset.optionValue;

        // Find matching variant via data-variant-id on the clicked pill
        var variantId = pill.dataset.variantId;
        if (variantId && atcBtn) {
          atcBtn.dataset.startingVariant = variantId;

          // Update price via Shopify variants JSON
          fetch('/products/' + window.__mercheProductHandle + '.js')
            .then(function(r) { return r.json(); })
            .catch(function() { return null; });
        }
      });
    });

    // ATC
    if (atcBtn) {
      atcBtn.addEventListener('click', function() {
        if (atcBtn.disabled) return;
        var variantId = atcBtn.dataset.startingVariant;
        if (!variantId) return;
        atcBtn.textContent = 'Adding...';
        atcBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          atcBtn.textContent = 'Added!';
          setTimeout(function() {
            atcBtn.textContent = 'Add to Cart';
            atcBtn.disabled = false;
          }, 1800);
          // Open cart drawer if present
          var drawer = document.querySelector('.cart-drawer');
          if (drawer) {
            drawer.classList.add('open');
            document.querySelector('.cart-overlay') && document.querySelector('.cart-overlay').classList.add('open');
            if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer();
          }
        })
        .catch(function() {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.disabled = false;
        });
      });
    }

    // Description paragraph spacing
    function applyDescSpacing() {
      var desc = document.querySelector('.product-description');
      if (!desc) return;
      desc.querySelectorAll('p').forEach(function(p, i) {
        if (i > 0) p.style.marginTop = '1.4em';
      });
    }
    applyDescSpacing();
    var container = document.querySelector('.product-details') || document.body;
    new MutationObserver(applyDescSpacing).observe(container, { childList: true, subtree: true });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    // Gallery thumb swap
    var mainImg = document.querySelector('.gallery-main img');
    if (mainImg) {
      document.querySelectorAll('.thumb[data-src]').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          document.querySelectorAll('.thumb').forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          mainImg.src = thumb.dataset.src;
        });
      });
    }

    // Product description paragraph spacing — applied via inline style so it
    // survives any app-triggered DOM re-renders of the description content.
    function applyDescSpacing() {
      var desc = document.querySelector('.product-description');
      if (!desc) return;
      desc.querySelectorAll('p').forEach(function(p, i) {
        if (i > 0) p.style.marginTop = '1.4em';
      });
    }

    applyDescSpacing();

    // Re-apply after any DOM change inside .product-details (catches app re-renders)
    var container = document.querySelector('.product-details') || document.body;
    new MutationObserver(applyDescSpacing).observe(container, { childList: true, subtree: true });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritual-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-rotator]').forEach(function(rotator) {
      var slides = rotator.querySelectorAll('.ritual-banner-slide');
      if (slides.length < 2) return;
      var current = 0;
      var interval = parseInt(rotator.dataset.interval) || 5000;
      setInterval(function() {
        var next = (current + 1) % slides.length;
        slides[current].classList.add('is-leaving');
        slides[current].classList.remove('is-active');
        setTimeout(function() {
          slides[current].classList.remove('is-leaving');
          current = next;
          slides[current].classList.add('is-active');
        }, 800);
      }, interval);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
